import { Link } from "react-router-dom";
import "./Footer.scss";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="site-footer__body">
        {/* Brand */}
        <div className="site-footer__brand">
          <Link to="/" className="brand-logo">
            <img src="/logo-gky.png" alt="RTC GKY" />
            <span>RTC GKY</span>
          </Link>
          <p>
            Komunitas pria di lingkungan GKY Greenville yang dibentuk sebagai
            ruang pertumbuhan, pembinaan, dan persekutuan bersama.
          </p>
        </div>

        {/* Navigasi */}
        <div className="site-footer__col">
          <h5>Navigasi</h5>
          <ul>
            <li><Link to="/">Beranda</Link></li>
            <li><Link to="/events">Event</Link></li>
          </ul>
        </div>

        {/* Kontak */}
        <div className="site-footer__col">
          <h5>Kontak</h5>
          <ul>
            <li><a href="mailto:admin@rtcgky.com">admin@rtcgky.com</a></li>
            <li><a href="https://wa.me/+6281380805610" target="_blank" rel="noreferrer">WhatsApp</a></li>
          </ul>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="site-footer__bottom">
        <div className="site-footer__bottom-inner">
          <p>© {year} RTC GKY · All rights reserved</p>
          <p>Made with ♥ for the church</p>
        </div>
      </div>
    </footer>
  );
}
